import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { getApiUrl, apiList } from 'src/app/core/Constants/apiList';
import { RoleManagePayload } from 'src/app/core/Models/interfaces/payloads/roleManagePayload';
import { ApiResponse } from 'src/app/core/Models/interfaces/responseData';

@Injectable({
  providedIn: 'root'
})
export class RolesService {

constructor(
  private http: HttpClient,
) { }

public getRoleDetails(id: number): Observable<ApiResponse> {
  let endpoint = getApiUrl(apiList.role.getRolesDetails, null, { id });
  return this.http.get<ApiResponse>(endpoint);
}
public addRole(payload: RoleManagePayload): Observable<ApiResponse> {
  let endpoint = getApiUrl(apiList.role.roles);
  return this.http.post<ApiResponse>(endpoint, payload);
}

public editRole(payload: RoleManagePayload, id: number): Observable<ApiResponse> {
  let endpoint = getApiUrl(`${apiList.role.roles}/${id}`);
  return this.http.put<ApiResponse>(endpoint, payload);
}

}
